import { render, staticRenderFns } from "./cdwritreason.vue?vue&type=template&id=d1a15e2a&scoped=true&"
import script from "./cdwritreason.vue?vue&type=script&lang=js&"
export * from "./cdwritreason.vue?vue&type=script&lang=js&"
import style0 from "./cdwritreason.vue?vue&type=style&index=0&id=d1a15e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a15e2a",
  null
  
)

export default component.exports